import { normalizeMediaUrls } from './internal/normalize-media-urls';
import { removeDomainAndAddLanguagePrefixesInLinks } from './internal/remove-domain-and-add-language-prefixes-in-links';

/**
 * Transforms the URLs in the response data by normalizing media URLs and
 * removing the domain while adding language prefixes in links.
 *
 * @template T - The type of the data object, which extends a record with string keys and unknown values.
 * @param {T} data - The data object containing URLs to be transformed.
 * @param {string} [nonDefaultLocale] - An optional locale string to be used for adding language prefixes in links.
 * @returns {T} - The transformed data object with updated URLs.
 */
export const transformResponseUrls = <T extends Record<string, unknown>>(
  data: T,
  nonDefaultLocale?: string
): T => {
  const dataWithNormalizedMediaUrls = normalizeMediaUrls(data);
  return removeDomainAndAddLanguagePrefixesInLinks(dataWithNormalizedMediaUrls, nonDefaultLocale);
};
